module.exports = __webpack_public_path__ + "images/mstile-144x144-cbe31ea4245e623a602eb836eae8701b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/mstile-144x144.png
// module id = ./src/images/favicons/mstile-144x144.png
// module chunks = 1